/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ResumesInputs */

const en_nav_resumes = /** @type {(inputs: Nav_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumes`)
};

const de_nav_resumes = /** @type {(inputs: Nav_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebensläufe`)
};

const fr_nav_resumes = /** @type {(inputs: Nav_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const es_nav_resumes = /** @type {(inputs: Nav_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículums`)
};

const it_nav_resumes = /** @type {(inputs: Nav_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum`)
};

const nl_nav_resumes = /** @type {(inputs: Nav_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV's`)
};

const pl_nav_resumes = /** @type {(inputs: Nav_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const fi_nav_resumes = /** @type {(inputs: Nav_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansiosihteerit`)
};

const da_nav_resumes = /** @type {(inputs: Nav_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV'er`)
};

const sv_nav_resumes = /** @type {(inputs: Nav_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

/**
* | output |
* | --- |
* | "Resumes" |
*
* @param {Nav_ResumesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_resumes = /** @type {((inputs?: Nav_ResumesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ResumesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_resumes(inputs)
	if (locale === "fr") return fr_nav_resumes(inputs)
	if (locale === "es") return es_nav_resumes(inputs)
	if (locale === "it") return it_nav_resumes(inputs)
	if (locale === "nl") return nl_nav_resumes(inputs)
	if (locale === "pl") return pl_nav_resumes(inputs)
	if (locale === "fi") return fi_nav_resumes(inputs)
	if (locale === "da") return da_nav_resumes(inputs)
	if (locale === "sv") return sv_nav_resumes(inputs)
	return en_nav_resumes(inputs)
});